// 保留网关前缀（如 /fat）；不能用 new URL('/api/...', base)，否则会丢失前缀。
export function getApiDownloadUrl(url, params) {
  if (typeof url !== 'string' || !url.startsWith('/api/')) {
    throw new Error('下载链接无效')
  }
  const base = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '')
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(params || {})) {
    if (value !== undefined && value !== null) query.set(key, value)
  }
  return `${base}${url}${query.size ? `${url.includes('?') ? '&' : '?'}${query}` : ''}`
}

// 浏览器原生下载，不读取 Blob、不附加登录 token；文件名由服务端决定。
export function downloadFile(url, _filename, params) {
  const link = document.createElement('a')
  link.href = getApiDownloadUrl(url, params)
  link.rel = 'noopener'
  document.body.appendChild(link)
  try {
    link.click()
  } finally {
    link.remove()
  }
  return true
}
